// TODO remove after implementing Stripe v3
(() => {
	const SubscriptionController = (
		$scope,
		$rootScope,
		$location,
		$http,
		$timeout,
		$route,
		paymentVariablesService,
		accountService,
		messageService,
		stringModifierService,
		userService,
		stripeDataService,
		subscriptionService
	) => {
		const request = {
			sendFeedback(feedback) {
				const formData = new FormData();
				formData.append('feedback', feedback);
				$http({
					method: 'POST',
					url: '/protected/rest/unsubscribe/send',
					data: {
						feedback
					},
					transformRequest: stringModifierService.urlEncodDataTransform,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				});
			},
			getKeyForNotSubscribedUser(
				getKeyForNotSubscribedUserSuccessCallback,
				getKeyForNotSubscribedUserErrorCallback
			) {
				$http({
					method: 'GET',
					url: '	/public/rest/stripe/pk',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					transformRequest: stringModifierService.urlEncodDataTransform
				})
					.then(result => {
						getKeyForNotSubscribedUserSuccessCallback(result.data);
					})
					.catch(() => {
						getKeyForNotSubscribedUserErrorCallback();
					});
			},
			unsubscribeStripe(
				subscription,
				unsubscribeStripeSuccessCallback,
				unsubscribeStripeErrorCallback
			) {
				$http({
					method: 'POST',
					url: '/protected_base/rest/stripe/unsubscribe',
					data: {
						subscription
					},
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					transformRequest: stringModifierService.urlEncodDataTransform
				})
					.then(result => unsubscribeStripeSuccessCallback(result.data))
					.then(() => getUserDetails())
					.catch(() => unsubscribeStripeErrorCallback());
			}
		};

		$scope.$on('$viewContentLoaded', () => {
			accountService.setNavigationSettings(null, null, null);
			getUser();
			// subscriptionService.getUserSubscription();
			delete $rootScope.menu_path;
			$scope.expires = false;
			$scope.unsibscribe_show = false;
			stripeDataService
				.getStripeUserKey()
				.subscribe(
					data => getKeyForNotSubscribedUserSuccessCallback(data),
					error => getKeyForNotSubscribedUserErrorCallback(error)
				);
		});

		$scope.$on('$destroy', () => {
			$scope.userObservable.unsubscribe();
		});

		function getUser() {
			$scope.userObservable = accountService.userDataObservable.subscribe(
				user => {
					if (user !== null && typeof user !== 'undefined') {
						$scope.user = JSON.parse(JSON.stringify(user));
						// const {monthlyDiscount, annualDiscount} = userService.subscriptionData;
						$scope.isAnnualDiscount =
							$scope.user.subscriptionPrice.annualDiscountPrice ||
							$scope.user.subscriptionPrice.annualDiscountPrice === 0;
						$scope.isMonthlyDiscount =
							$scope.user.subscriptionPrice.monthlyDiscountPrice ||
							$scope.user.subscriptionPrice.monthlyDiscountPrice === 0;
					}
				}
			);
		}

		function getKeyForNotSubscribedUserErrorCallback(error) {
			messageService.showDefaultErrorMessage(error);
		}

		function getKeyForNotSubscribedUserSuccessCallback(data) {
			if (data) {
				if (data.message) {
					$rootScope.stripePK = data.message;
					Stripe.setPublishableKey($rootScope.stripePK);
					accountService.setNavigationSettings(null, null, null);
					$rootScope.removeBg = 'true';
					$rootScope.navbarSignUp = true;
					$rootScope.navbarSignIn = false;
				}
			}
		}

		$scope.subscribeStripe = function(plan) {
			if (!$scope.enabled) {
				paymentVariablesService.setPlan(plan);
				subscriptionService.setSubscription(plan);
				$('#cardDetailsModal').modal('hide');
			}
		};

		$scope.subscribeStripeModal = function(plan, e) {
			subscriptionService.subscribeStripeModalWeb(plan, e);
		};

		$scope.unsubscribe = function(feedback) {
			$scope.button_disable = true;
			$('#unsubscribeConfirm').modal('hide');

			if (feedback) {
				stripeDataService.sendFeedback(feedback).subscribe();
			} else {
				stripeDataService
					.sendFeedback(
						`User with email - ${
							$scope.user.email
						} unsubscribed without feedback.`
					)
					.subscribe();
			}

			stripeDataService
				.unsubscribeStripe($scope.subscription)
				.subscribe(data => {
					unsubscribeStripeSuccessCallback(data);
					getUserDetails();
				}, error => unsubscribeStripeErrorCallback);
		};

		$scope.logout = () => {
			accountService.logoutWeb();
		};

		function unsubscribeStripeErrorCallback(error) {
			messageService.showDefaultErrorMessage(error);
		}

		function unsubscribeStripeSuccessCallback(data) {
			if (data) {
				if (data.callResponce && data.callResponce.errorMessage) {
					toastr.error(data.callResponce.errorMessage);
				} else if (data.message) {
					toastr.info(data.message);
				}
				$scope.button_disable = false;
			} else {
				console.log('no data');
			}
		}

		function getUserDetails() {
			accountService.getUserWeb().subscribe(data => {
				if (data.enabled) {
					$rootScope.removeBg = 'blah';
				}
			});

			// subscriptionService.getUserSubscription();
		}
	};

	// angular
	// 	.module('main')
	// 	.controller('SubscriptionController', SubscriptionController);

	SubscriptionController.$inject = [
		'$scope',
		'$rootScope',
		'$location',
		'$http',
		'$timeout',
		'$route',
		'paymentVariablesService',
		'accountService',
		'messageService',
		'stringModifierService',
		'userService',
		'stripeDataService',
		'subscriptionService'
	];
})();



// WEBPACK FOOTER //
// ./web/js/controllers/subscriptionController.js